import { usePostOfficeRoute } from '@atlassian/post-office-context/store';

export const usePostOfficeSearchParams = (): Record<string, string> => {
	const route = usePostOfficeRoute();

	let result: Record<string, string> = {};

	if (route?.searchParams) {
		result = Object.fromEntries(route.searchParams);
	}

	if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') {
		result = { ...result, pathname: window.location.pathname };
	}

	return result;
};
